<script lang="ts" setup>
import type { RichTextBlockV2Schema } from '~/types/storyblok/rich-text-block-v2'

const props = defineProps<{ blok: RichTextBlockV2Schema }>()

const parsedContent = useRichtext(computed(() => props.blok.content))
</script>

<template>
  <div
    v-editable="blok"
    v-html="parsedContent"
  />
</template>
